import { createApiActions } from '@shared/ngrx-factory/factory.actions';
import { PageableParamInput } from '@modules/external-services/company-management/requests/pageable-param.search';
import { SupplierDashboardData } from '../responses/supplier-dashboard.response';
import { PageableResponse } from '@modules/financial-security-configuration/responses/get-financial-security.response';
import { SupplierApplication, RevokeSupplierPrequalificationResponse } from '../responses/supplier-applications.response';

export const SupplierDashboardActions = createApiActions<
  null,
  SupplierDashboardData
>('Supplier Dashboard', 'Load Dashboard');

export const SupplierApplicationsActions = createApiActions<
  PageableParamInput,
  PageableResponse<SupplierApplication>
>('Supplier Management', 'Load Supplier Applications');

export const ViewSupplierApplicationActions = createApiActions<
  string,
  SupplierApplication
>('Supplier Management', 'View Supplier Application');

export const RevokeSupplierPrequalificationActions = createApiActions<
  { preQualificationUuid: string },
  RevokeSupplierPrequalificationResponse
>('Supplier Management', 'Revoke Supplier Prequalification');

